import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL =  process.env.REACT_APP_API_URL;

const uploadImage = async (formData) => {
  const response = await axios.post(API_URL + "/api/images/uploadImage", formData, {
    headers: {
      ...authHeader(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const updateImage = async (formData) => {
  const response = await axios.put(API_URL + "/api/images/updateImage", formData, {
    headers: {
      ...authHeader(),
      "Content-Type": "multipart/form-data",
    },
  });
  console.log("API Response Data:", response.data);
  return response.data;
};






const ImageApi = {
  uploadImage,
  updateImage
};

export default ImageApi;
